import { CommandActionAsync } from "src/app/abstract/command/command-action-async.service";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { Injectable } from "@angular/core";
import { CloneService } from "../clone/clone.service";
import { WidgetsService } from "../widgets/widgets.service";
import { Logger } from "src/app/core/logger";
import { WidgetsMetadataService } from "../widgets/widgets-metadata.service";

@Injectable()
export class CommandResequenceQuestionsService extends CommandActionAsync {
    constructor(private widgetsCloneService: CloneService,
        private widgetsService: WidgetsService,    
        private widgetsMetadataService: WidgetsMetadataService,
        private logger:Logger) {
        super();
    }

    /**
     * Resequence questions inside a provided root node
     * @param origin (Sub)Node where to start resequencing
     * @param unused
     * @returns Number of Questions hit
     */
    public async executeAsync(origin:WidgetsAbstract, unused: WidgetsAbstract|undefined): Promise<number> {
        if (origin) {
            const numQuestions = await this.widgetsService.resequenceQuestions(origin);
            if (numQuestions) {
                // this.logger.log('Resequencing questions (' + numQuestions + ')' );                
                return numQuestions;
            } else
                throw new Error("No Questions Found");           
        }
        throw new Error("Origin Node is null/undefined. Can't resequence.");
    }
}
